import { profileRoute } from '../Profile/route.const'

export const myVehicleRoute = () => `${profileRoute()}/vehicle`
